import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const BillsModule = {
  namespaced: true,
  state: {},
  actions: {
    async changeInvoiceChannel ({ commit, state, rootGetters }, { invoiceChannelType }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation changeBills ($invoiceChannel: InvoiceChannelType!) {
          changeInvoiceChannel (invoiceChannel: $invoiceChannel) {
            success
            invoiceChannel
          }
        }`,
        variables: {
          invoiceChannel: invoiceChannelType
        }
      }).then((response) => {
        return response.data.changeInvoiceChannel
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {},
  getters: {}
}

export {
  BillsModule
}
